import React from 'react';
import BannerWrapper from '../../BannerWrapper';

class NativeSpacing320x16 extends React.Component {
  render() {
    let pagedetails = this.props.pagedetails;
    let height = `${pagedetails.height}px`;

    if (height === undefined) {
      return null;
    }
    return <div className="space-comp" style={{ height }} />;
  }
}

export default BannerWrapper(NativeSpacing320x16);
